module.exports = __webpack_public_path__ + "phone.b802f433.png";